import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'CapitalizeFirst' })
export class CapitalizeFirstPipe implements PipeTransform {

    transform(value): any {
        if (typeof value == 'string') {
            return value[0].toUpperCase() + value.substr(1);
        }

        return value;
    }
}



@Pipe({ name: 'limit', pure: false })
export class LimitPipe implements PipeTransform {

    transform(value: any[], count: number = 3): any[] {
        if (Array.isArray(value) && typeof count === 'number' && count > 0) {
            return Array.prototype.slice.apply(value, [0, count]);
        }

        return value;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/capitalize-first.pipe.ts